module.exports = __webpack_public_path__ + "img/calendar-2.67e7507b.svg";